import { tv, type VariantProps } from 'tailwind-variants'

export const bulletVariants = tv({
  slots: {
    base: 'flex flex-wrap rounded-full items-center justify-center origin-center web:select-none px-1',
    text: 'text-center w-full font-nunito font-bold text-xs items-center justify-center',
  },
  variants: {
    variant: {
      solid: {},
      flat: {},
    },
    size: {
      sm: { text: 'native:max-h-4' },
      md: {
        text: 'native:max-h-4',
      },
      lg: { text: 'native:max-h-5 text-sm' },
      xl: { text: 'text-sm' },
    },
    isInvisible: {
      true: {
        base: 'scale-0 opacity-0',
      },
    },
    isOneChar: {
      true: {
        base: 'px-0',
        text: 'web:whitespace-nowrap',
      },
    },
    isDot: {
      true: {},
    },
    showOutline: {
      true: {
        base: 'border-2 border-layout-background',
      },
      false: {
        base: 'border-0 border-transparent',
      },
    },
  },
  defaultVariants: {
    variant: 'solid',
    size: 'md',
    showOutline: true,
    isInvisible: false,
    isDot: false,
    isOneChar: false,
  },
  compoundVariants: [
    // solid
    {
      variant: 'solid',
      class: {
        base: 'bg-primary-bg-inverse',
        text: 'text-primary-label-solid',
      },
    },
    // flat
    {
      variant: 'flat',
      class: {
        base: 'bg-primary-bg-medium',
        text: 'text-primary-label-light',
      },
    },
    // isDot / size
    {
      isDot: true,
      size: 'sm',
      class: {
        base: 'h-3 w-3',
      },
    },
    {
      isDot: true,
      size: 'md',
      class: {
        base: 'h-3.5 w-3.5',
      },
    },
    {
      isDot: true,
      size: 'lg',
      class: {
        base: 'h-4 w-4',
      },
    },
    {
      isDot: true,
      size: 'xl',
      class: {
        base: 'h-5 w-5',
      },
    },
    // isDot(false) / isOneChar(true) / size
    {
      isDot: false,
      isOneChar: true,
      size: 'sm',
      class: {
        base: 'h-4 w-4 native:w-5 native:h-5',
      },
    },
    {
      isDot: false,
      isOneChar: true,
      size: 'md',
      class: {
        base: 'h-5 w-5',
      },
    },
    {
      isDot: false,
      isOneChar: true,
      size: 'lg',
      class: {
        base: 'h-6 w-6',
      },
    },
    {
      isDot: false,
      isOneChar: true,
      size: 'xl',
      class: {
        base: 'h-8 w-8',
      },
    },
    // isDot(false) / isOneChar(false) / size
    {
      isDot: false,
      isOneChar: false,
      size: 'sm',
      class: {
        base: 'web:h-4 native:h-5',
      },
    },
    {
      isDot: false,
      isOneChar: false,
      size: 'md',
      class: {
        base: 'h-5',
      },
    },
    {
      isDot: false,
      isOneChar: false,
      size: 'lg',
      class: {
        base: 'h-6 px-1.5',
      },
    },
    {
      isDot: false,
      isOneChar: false,
      size: 'xl',
      class: {
        base: 'h-8 px-2',
      },
    },
  ],
})

export type TBulletVariantProps = VariantProps<typeof bulletVariants>
export type TBulletSlots = keyof ReturnType<typeof bulletVariants>
